// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light native-style tooltip (matches the browser-default tooltip look) */
.light-tooltip .tooltip-inner {
  background-color: #f2f2f2;
  color: #212529;
  border: 1px solid #c6c6c6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.light-tooltip.bs-tooltip-left .arrow::before {
  border-left-color: #c6c6c6;
}
.light-tooltip.bs-tooltip-right .arrow::before {
  border-right-color: #c6c6c6;
}
.light-tooltip.bs-tooltip-top .arrow::before {
  border-top-color: #c6c6c6;
}
.light-tooltip.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #c6c6c6;
}
`, "",{"version":3,"sources":["webpack://./src/components/LightTip.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Light native-style tooltip (matches the browser-default tooltip look) */\n.light-tooltip .tooltip-inner {\n  background-color: #f2f2f2;\n  color: #212529;\n  border: 1px solid #c6c6c6;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.light-tooltip.bs-tooltip-left .arrow::before {\n  border-left-color: #c6c6c6;\n}\n.light-tooltip.bs-tooltip-right .arrow::before {\n  border-right-color: #c6c6c6;\n}\n.light-tooltip.bs-tooltip-top .arrow::before {\n  border-top-color: #c6c6c6;\n}\n.light-tooltip.bs-tooltip-bottom .arrow::before {\n  border-bottom-color: #c6c6c6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
